import React from "react";
import styles from "./OverlayLoader.module.css";
// import CircularProgress from "@mui/material/CircularProgress";
// import Box from "@mui/material/Box";

const OverlayLoader = ({
  loading,
  count = 3,
  background = "rgba(255, 255, 255, 0.5)",
}) => {
  if (!loading) {
    return null;
  }

  return (
    // 11111

    // <div className={`${styles.loaderOverlay} ${loading ? styles.loading : ""}`}>
    //   <div className={loading ? styles.loader : styles.unLoading}>
    //     <Box sx={{ display: "flex" }}>
    //       <CircularProgress />
    //     </Box>
    //     <p className={styles.loadingText}>Loading...</p>
    //   </div>
    // </div>

    // 22222

    // <div className={styles.loaderOverlay}>
    //   <div className={styles.loader}></div>
    // </div>

    // 33333

    // <div className={styles.loaderOverlay}>
    //   {[...Array(count)].map((_, index) => (
    //     <div key={index} className={styles.loader}></div>
    //   ))}
    // </div>

    // 44444

    // <div className={styles.overlay} style={{ backgroundColor: background }}>
    //   <div className={styles.loader}>
    //     <div className={styles.ball}></div>
    //     <div className={styles.ball}></div>
    //     <div className={styles.ball}></div>
    //   </div>
    // </div>

    // 55555

    <div className={styles.overlay} style={{ backgroundColor: background }}>
      <div className={styles.loader}>
        <div className={styles.ball}></div>
        <div className={styles.ball}></div>
        <div className={styles.ball}></div>
      </div>
    </div>

    // 66666

    // <div className={styles.overlay}>
    //   <div className={styles.loader}>
    //     <div className={styles.circle}></div>
    //     <div className={styles.circle}></div>
    //     <div className={styles.circle}></div>
    //   </div>
    // </div>
  );
};

export default OverlayLoader;
